// A near-leaf module so anything deep in the tree - a diagnostics provider, an
// adapter - can read the SDK version without importing src/index.js and risking
// a circular import back down into whatever it lives inside of. Its only import
// is `config/env.js`, which is itself a pure leaf, so that property holds.
//
// The value is baked in at build time from package.json (see vite.config.js's
// `define`), which is what keeps `VERSION`, the diagnostics `sdkVersion`, and
// the deployed channel bundle reporting the same number.
import { config } from '../config/env.js';

export const SDK_VERSION = config.version;

// Build-identity metadata, not the human-bumped SDK_VERSION - it changes on
// every build (a git short SHA), so it's what actually answers "is this the
// build I just deployed?" rather than "what's the last version I bumped".
// `BUILD_ID` composes both into one glanceable value (semver build-metadata
// syntax, `<version>+<sha>`); boot() logs it on every call precisely so that
// question is answerable from a live page's console instead of by curling
// and grepping the deployed bundle by hand.
export const SDK_BUILD_SHA = config.buildSha;
export const SDK_BUILT_AT = config.builtAt;
export const BUILD_ID = `${SDK_VERSION}+${SDK_BUILD_SHA}`;
